import AppRoutes from './routes.js';

function App() {
  return (
    <AppRoutes/>
  )
}

export default App;
